import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Page } from '@shapeable/gesda-types';
import { SliceLayoutBoundary, SiteHeaderLayout, EntityBannerProps, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutProps, BackButtonEntityProvider, DownloadButton, ExplorerTabs } from '@shapeable/ui';
import { ExplorerProvider } from '../providers/explorer-provider';
import { RadarChartMain } from '../elements/radar-chart-main';
import { RadarChart } from '../elements/radar-chart';
import { PagePublicationGridLayout } from './page-publication-grid-layout';
import { GESDA_PURPLE, GESDA_PURPLE_DARK } from '../../theme';
const cls = classNames('page-publications-explorer-layout');

// -------- Types -------->

type RadarProps = {
  isInteractive: boolean;
}

// -------- Props -------->

export type PagePublicationsExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & {  
  entity?: Page;
  bannerProps?: Omit<EntityBannerProps, 'entity'>;
  showRadar?: boolean;
  isAsideSticky?: boolean;
};

export const PagePublicationsExplorerLayoutDefaultProps: Omit<PagePublicationsExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
  isAsideSticky: false,
  showRadar: true,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};

    .shp--page-half-banner__title {
      font-family: ${theme.FONT('sans')};
      font-size: 0.75em;
      font-weight: 600;
      color: ${theme.COLOR(GESDA_PURPLE_DARK)};
    }
  `,
  desktopFullHD: css`
    .shp--page-half-banner__title {
      font-size: 1.1em;
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});


const RadarChartStyles = breakpoints({
  base: css`

    ${({ isInteractive }: RadarProps ) => !isInteractive && css`
      margin-top: ${theme.UNIT(3)};
      opacity: 0.4;
      filter: saturate(0.4);
    `}
  `,
});

const DownloadButtonStyles = breakpoints({
  base: css`
    max-width: 460px;
  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
      Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
      Radar: styled(RadarChart)<RadarProps>`${RadarChartStyles}`,

      DownloadButton: styled(DownloadButton)`${DownloadButtonStyles}`,
};

export const PagePublicationsExplorerLayout: Shapeable.FC<PagePublicationsExplorerLayoutProps> = (props) => {
  const { className, children, entity, bannerProps, showRadar, isAsideSticky, ...explorerEntityDetailsProps } = props;

  return (
    <ExplorerProvider>
    <BackButtonEntityProvider value={entity.parent}>
    <My.Container>
      <SliceLayoutBoundary boundary='none' >
        <My.Layout 
          entity={entity}
          className={cls.name(className)}
          {...explorerEntityDetailsProps}
          asideMaxWidth={800}
          isAsideSticky={true}
          stickyTopOffset={95}
          asideIsOffset={false}
          showAsideHeader={false}
          
          dataVizMain={
            <RadarChartMain />
          }

          content={
            <PagePublicationGridLayout entity={entity} />
          }

          dataViz={
            <RadarChart initialY={10} />
          }
          // metaHead={
          //   <PageMetaLayout
          //     entity={entity} />
          // }
        />
        </SliceLayoutBoundary>
    </My.Container>
    </BackButtonEntityProvider>
    </ExplorerProvider>
  )
};

PagePublicationsExplorerLayout.defaultProps = PagePublicationsExplorerLayoutDefaultProps;
PagePublicationsExplorerLayout.cls = cls;